import { Spin } from 'antd';

const Loader = () => {
    return (
        <Spin className="fabric-spin" size="large" />
    )
}

export default Loader;